import { render, staticRenderFns } from "./MacroTitle.vue?vue&type=template&id=3745fe60&"
import script from "./MacroTitle.vue?vue&type=script&lang=js&"
export * from "./MacroTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3745fe60')) {
      api.createRecord('3745fe60', component.options)
    } else {
      api.reload('3745fe60', component.options)
    }
    module.hot.accept("./MacroTitle.vue?vue&type=template&id=3745fe60&", function () {
      api.rerender('3745fe60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/MacroTitle/MacroTitle.vue"
export default component.exports